import React from 'react';
import PropTypes from 'prop-types';
import css from './NoReasonsFound.css';

export default class NoReasonsFound extends React.Component {
  render() {
    return (
      <div className={css['container']}>
        Oops, looks like scheduling an appointment is not an option here. 
        We suggest you to try other ways to contact {this.props.name}.
      </div>
    );
  }
}

NoReasonsFound.propTypes = {
  name: PropTypes.string.isRequired
};
